import React from "react";
import { Route, Routes } from "react-router";
import asyncComponent from "components/AsyncComponent";
import { Atlas } from "@nikkei/atlas-react";
import Popup from "containers/common/Popup";
import Pdf from "components/Pdf";
import PdfViewer from "features/PdfjsViewer";
import NotFound from "features/NotFound";
import { Debug } from "features/DebugPage";
import { Auth } from "features/Auth";
import { useMediaLayout } from "hooks/useMedia";
import { BrowserRouter, Outlet } from "react-router-dom";

const Main = asyncComponent(() =>
  import("features/Main").then(module => module.default)
);
const AccessControl = asyncComponent(() =>
  import("features/AccessControl").then(module => module.default)
);
const Home = asyncComponent(() =>
  import("containers/pages/home").then(module => module.default)
);
const History = asyncComponent(() =>
  import("containers/pages/history").then(module => module.default)
);
const Login = asyncComponent(() =>
  import("features/Login").then(module => module.Login)
);
const Rights = asyncComponent(() =>
  import("components/Rights").then(module => module.default)
);
const Policy = asyncComponent(() =>
  import("components/Policy").then(module => module.default)
);
const Disclaimer = asyncComponent(() =>
  import("components/Disclaimer").then(module => module.default)
);
const DomesticCorporation = asyncComponent(() =>
  import("containers/pages/corp").then(module => module.default)
);
const Industry = asyncComponent(() =>
  import("containers/pages/industry").then(module => module.default)
);
const IndustrySearch = asyncComponent(() =>
  import("./features/IndustrySearch").then(module => module.default)
);
const Tool = asyncComponent(() =>
  import("containers/pages/tool").then(module => module.default)
);

const Article = asyncComponent(() =>
  import("components/Article").then(module => module.default)
);

const SearchList = asyncComponent(() =>
  import("./features/SearchList").then(module => module.default)
);

const Search = asyncComponent(() =>
  import("components/CorporationIndustry/Search").then(module => module.default)
);

const SearchIndsutry = asyncComponent(() =>
  import("./features/IndustrySearch").then(module => module.default)
);

const Macro = asyncComponent(() =>
  import("containers/pages/macro").then(module => module.default)
);

const Sample = asyncComponent(() =>
  import("containers/pages/sample").then(module => module.default)
);

const Setting = asyncComponent(() =>
  import("containers/Setting").then(module => module.default)
);

const Binder = asyncComponent(() =>
  import("./features/BinderPage").then(module => module.BinderPage)
);

const Recommendation = asyncComponent(() =>
  import("./features/Recommendation").then(module => module.default)
);

const DataDefinition = asyncComponent(() =>
  import("./features/DataDefinition").then(module => module.default)
);

const ProtectedLayout = () => (
  <Auth>
    <Main>
      <AccessControl>
        <Outlet />
      </AccessControl>
    </Main>
  </Auth>
);

const App = () => {
  useMediaLayout({ maxWidth: "520px" });

  return (
    <BrowserRouter>
      <React.Fragment>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/pdf-viewer" element={<PdfViewer />} />
          <Route path="/*" element={<ProtectedLayout />}>
            <Route index element={<Home />} />
            <Route path="recommendation" element={<Recommendation />} />
            <Route path="binder/*" element={<Binder />} />
            <Route path="home/*" element={<Home />} />
            <Route path="gohome" element={<Home />} />
            <Route path="corp/*" element={<DomesticCorporation />} />
            <Route path="industry/*" element={<Industry />} />
            <Route path="industrySearch" element={<IndustrySearch />} />
            <Route path="tool/*" element={<Tool />} />
            <Route path="article/*" element={<Article />} />
            <Route path="searchlist/*" element={<SearchList />} />
            <Route path="search/*" element={<Search />} />
            <Route path="industry-search/*" element={<SearchIndsutry />} />
            <Route path="history" element={<History />} />
            <Route path="rights" element={<Rights />} />
            <Route path="policy" element={<Policy />} />
            <Route path="disclaimer" element={<Disclaimer />} />
            <Route path="macro/*" element={<Macro />} />
            <Route path="popup" element={<Popup />} />
            <Route path="pdf" element={<Pdf />} />
            <Route path="sample" element={<Sample />} />
            <Route path="data-definition/*" element={<DataDefinition />} />
            <Route path="setting/*" element={<Setting />} />
            <Route path="debug/*" element={<Debug />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
        {MODE === "production" && (
          <Atlas
            provideReferrer={true}
            trackingHtmlUrl="/vs-atlas/tracking.rev-d097ff0.html"
          />
        )}
      </React.Fragment>
    </BrowserRouter>
  );
};

export default App;
